import { Redirect, useLocation } from 'react-router-dom';

// Creating a redirect from LLM Control Center to GenAI Ops Hub
export const RedirectToGenAIOpsHub = () => {
  // Get the page name`
  const { pathname, search } = useLocation();

  // Get the project ID
  const searchParams = new URLSearchParams(search);
  const projectId = searchParams.get('project');

  // Get the page path
  const pageName = pathname.split('/')[2];
  const subPageName = pathname.split('/')[3];
  const pagePath = subPageName ? `${pageName}/${subPageName}` : pageName;

  const LLM_CENTER_TO_GENAI_HUB: { [key: string]: string } = {
    'benchmark-center/benchmarks': 'benchmark-center/benchmarks',
    'benchmark-center/data-bank': 'benchmark-center/data-bank',
    'command-center': '',
    'customer-preset-setup': '',
    'diversity-dashboard': 'diversity',
    'linter-center': 'linters',
  };

  const LLM_CENTER_TO_GENAI_HUB_PROJECT_AGNOSTIC: { [key: string]: string } = {
    'cheating-detection': 'tools/cheating-detection',
    'project-setup': 'project-setup',
  };

  const newProjectPage = LLM_CENTER_TO_GENAI_HUB[pagePath] ?? '';

  const newPageNoProject = LLM_CENTER_TO_GENAI_HUB_PROJECT_AGNOSTIC[pagePath] ?? '';

  const newPath = newProjectPage
    ? projectId
      ? newProjectPage
        ? `/genai-ops-hub/projects/${projectId}/${newProjectPage}`
        : `/genai-ops-hub/projects/${projectId}`
      : `/genai-ops-hub`
    : newPageNoProject
    ? `/genai-ops-hub/projects/${newPageNoProject}`
    : `/genai-ops-hub`;

  return <Redirect to={newPath} />;
};
